// src/components/Register.js
import React, { useState, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import '../styles/Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: ''
  });
  const [showError, setShowError] = useState(false);
  const [passwordError, setPasswordError] = useState('');
  const [termsAccepted, setTermsAccepted] = useState(false);
  const { register, error, loading } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setShowError(false);
    setPasswordError('');

    if (formData.password.length < 6) {
      setPasswordError('Password must be at least 6 characters');
      return;
    }

    if (!termsAccepted) {
      setPasswordError('You must accept the Terms of Use and Privacy Policy');
      return;
    }

    try {
      // Combining first and last name for the backend
      const userData = {
        name: `${formData.firstName} ${formData.lastName}`,
        email: formData.email,
        password: formData.password
      };
      
      await register(userData);
      navigate('/dashboard');
    } catch (err) {
      setShowError(true);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-logo">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="20" fill="#1A73E8"/>
          <path d="M20 10L28 25H12L20 10Z" fill="white"/>
        </svg>
        <h1>CRM App</h1>
      </div>
      
      <div className="auth-card">
        <h2>Create a new account</h2>
        
        {showError && (
          <div className="auth-error">
            {error || 'Registration failed. Please try again.'}
          </div>
        )}
        
        {passwordError && (
          <div className="auth-error">
            {passwordError}
          </div>
        )}
        
        <form onSubmit={handleSubmit}>
          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>
            
            <div className="form-group">
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          
          <div className="form-group">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {formData.email && !/^\S+@\S+\.\S+$/.test(formData.email) && (
              <div className="input-error">Enter a valid email address</div>
            )}
          </div>
          
          <div className="form-group">
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              minLength="6"
            />
            {formData.password && formData.password.length < 6 && (
              <div className="input-error">Enter a password with at least 6 characters</div>
            )}
          </div>
          
          <div className="form-check">
            <input
              type="checkbox"
              id="terms"
              checked={termsAccepted}
              onChange={() => setTermsAccepted(!termsAccepted)}
            />
            <label htmlFor="terms">
              I agree to the <Link to="/terms" className="text-link">Terms of Use</Link> and <Link to="/privacy" className="text-link">Privacy policy</Link>
            </label>
          </div>
          
          <button 
            type="submit" 
            className="btn-primary w-100"
            disabled={loading}
          >
            {loading ? (
              <span className="loading-spinner"></span>
            ) : (
              'Join Now'
            )}
          </button>
        </form>
        
        <div className="auth-footer">
          <p>Already have an account? <Link to="/login" className="auth-link">Log In</Link></p>
        </div>
      </div>
    </div>
  );
};

export default Register;